/* Onyra · offre limitée : compte à rebours vers une date fixe, puis tout s'éteint.
   Avec data-duree (en heures) : compte à rebours propre à chaque visiteuse, en heures, qui repart à zéro à chaque fin de cycle, sans jamais dépasser la fin de l'offre. */
(() => {
  const CLE = 'onyra-minuteur-fin';
  /* « 2026-10-31 23:59 » lu comme une heure de Paris, quel que soit le fuseau de la visiteuse. */
  function heureParis(texte) {
    const m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?/.exec(String(texte || '').trim());
    if (!m) return NaN;
    const t = Date.UTC(+m[1], m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
    const p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })
      .formatToParts(t)
      .forEach((x) => { p[x.type] = +x.value; });
    return t - (Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute) - t);
  }
  class OnyraOffre extends HTMLElement {
    connectedCallback() {
      this.finOffre = heureParis(this.dataset.fin);
      this.duree = (parseFloat(this.dataset.duree) || 0) * 3600000;
      this.fin = this.duree ? this.finVisiteuse() : this.finOffre;
      if (isNaN(this.fin)) return;
      this.tic();
      this.minuteur = setInterval(() => this.tic(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.minuteur);
    }

    /* Fin du cycle de cette visiteuse : gardée d'une page à l'autre, relancée quand elle est passée. */
    finVisiteuse() {
      const maintenant = Date.now();
      let fin = NaN;
      try { fin = parseInt(localStorage.getItem(CLE), 10); } catch (e) { /* stockage bloqué : cycle en mémoire */ }
      if (!(fin > maintenant) || fin - maintenant > this.duree) {
        fin = maintenant + this.duree;
        try { localStorage.setItem(CLE, String(fin)); } catch (e) { /* idem */ }
      }
      return isNaN(this.finOffre) ? fin : Math.min(fin, this.finOffre);
    }

    tic() {
      let reste = Math.max(0, Math.floor((this.fin - Date.now()) / 1000));
      if (!reste && this.duree && !(this.finOffre <= Date.now())) {
        this.fin = this.finVisiteuse();
        reste = Math.max(0, Math.floor((this.fin - Date.now()) / 1000));
      }
      if (!reste) {
        clearInterval(this.minuteur);
        this.hidden = true;
        const apres = this.nextElementSibling;
        if (apres && apres.hasAttribute('data-apres-offre')) apres.hidden = false;
        document.querySelectorAll('[data-apres-offre-annonce]').forEach((el) => { el.hidden = false; });
        return;
      }
      const u = this.duree
        ? { j: 0, h: Math.floor(reste / 3600), m: Math.floor((reste % 3600) / 60), s: reste % 60 }
        : { j: Math.floor(reste / 86400), h: Math.floor((reste % 86400) / 3600), m: Math.floor((reste % 3600) / 60), s: reste % 60 };
      this.querySelectorAll('[data-u]').forEach((el) => { el.textContent = String(u[el.dataset.u]).padStart(2, '0'); });
      this.querySelectorAll('[data-u-jours]').forEach((el) => { el.hidden = u.j === 0; });
    }
  }
  if (!customElements.get('onyra-offre')) customElements.define('onyra-offre', OnyraOffre);
})();
